import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
export const CountSteps = ()=>{
    const { t } = useLocaleKeys('integrations.count');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: t.stepOpenIntegrations()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: t.stepPasteApiKey()
            }),
            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                href: "http://help.sayanchor.com/en/articles/13737208-count",
                openInNewTab: true,
                style: {
                    marginTop: 16
                },
                testId: "count-help-center-link",
                children: t.readMoreInHelpCenter()
            })
        ]
    });
};
